export default __webpack_public_path__ + "static/media/amea.12d4c90a.svg";